import Image from 'next/image';
import Link from 'next/link';

/* eslint-disable-next-line */
type ImageHoverButtonProps = {
  buttonLabel: string;
  ctaLink: string;
  hoverImage: string;
  inactiveImage: string;
};

export function ImageHoverButton(props: ImageHoverButtonProps) {
  const { buttonLabel, ctaLink, hoverImage, inactiveImage } = props;

  return (
    <Link href={ctaLink} passHref>
      <a>
        <div className="group cursor-pointer h-full py-4 lg:py-0">
          <div className="group-hover:hidden block text-center">
            <Image
              alt="button icon"
              blurDataURL="/icons/blur-placeholder.png"
              height={180}
              placeholder="blur"
              src={hoverImage}
              width={180}
            />
          </div>
          <div className="group-hover:block hidden text-center">
            <Image
              alt="button icon"
              blurDataURL="/icons/blur-placeholder.png"
              height={180}
              placeholder="blur"
              src={inactiveImage}
              width={180}
            />
          </div>
          <p className="w-30 text-center border-y py-2 border-black text-overline lg:text-subtitle lg:text-header6">
            {buttonLabel}
          </p>
        </div>
      </a>
    </Link>
  );
}

export default ImageHoverButton;
